(function () {
  function isNumericValue(value) {
    return /^[0-9]+$/.test((value || '').trim());
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : value;
    return div.innerHTML;
  }

  class MMCartDrawer extends HTMLElement {
    connectedCallback() {
      this.itemsEl = this.querySelector('[data-mm-cart-items]');
      this.footerEl = this.querySelector('[data-mm-cart-checkout]').closest('.mm-cart-drawer__footer');

      this.querySelectorAll('[data-mm-cart-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });

      document.querySelectorAll('[data-cart-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        });
      });

      this.refresh();
    }

    open() {
      this.classList.add('is-open');
      document.body.classList.add('mm-cart-drawer-open');
    }

    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('mm-cart-drawer-open');
    }

    async refresh() {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await response.json();
      this.render(cart);
      return cart;
    }

    render(cart) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
      });

      this.footerEl.style.display = cart.items.length ? '' : 'none';

      if (!cart.items.length) {
        this.itemsEl.innerHTML = '<p class="mm-cart-drawer__empty">' + escapeHtml(window.mmCartStrings?.empty || 'Your cart is empty') + '</p>';
        return;
      }

      this.itemsEl.innerHTML = cart.items
        .map((item, index) => {
          const sizeOption = (item.options_with_values || []).find((option) => isNumericValue(option.value));
          const sizeLabel = (window.mmCartStrings && window.mmCartStrings.size) || 'Size';
          const sizeHtml = sizeOption
            ? '<span class="mm-cart-drawer__item-size"><span class="mm-cart-drawer__item-size-label">' +
              escapeHtml(sizeLabel) + '</span><span class="mm-cart-drawer__item-size-value">' +
              escapeHtml(sizeOption.value) + '</span><span class="mm-cart-drawer__item-size-mark"></span>' +
              '</span>'
            : '';

          return (
            '<div class="mm-cart-drawer__item" data-mm-cart-item data-line="' + (index + 1) + '">' +
              '<div class="mm-cart-drawer__item-media">' +
                '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' +
              '</div>' +
              '<div class="mm-cart-drawer__item-info">' +
                '<p class="mm-cart-drawer__item-title">' + escapeHtml(item.product_title) + '</p>' +
                '<div class="mm-cart-drawer__item-row">' +
                  '<span data-mm-price>' + formatMoney(item.final_price) + '</span>' +
                  sizeHtml +
                '</div>' +
                '<button type="button" class="mm-cart-drawer__item-remove" data-mm-cart-remove>' +
                  escapeHtml(window.mmCartStrings?.remove || 'Delete') +
                '</button>' +
              '</div>' +
            '</div>'
          );
        })
        .join('');

      this.itemsEl.querySelectorAll('[data-mm-cart-remove]').forEach((button) => {
        button.addEventListener('click', (event) => {
          const line = event.target.closest('[data-mm-cart-item]').dataset.line;
          this.removeLine(line);
        });
      });

      function formatMoney(cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'USD',
        });
      }
    }

    async add(variantId, quantity) {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] }),
      });
      await this.refresh();
      // Show the cart straight away once the item is in it.
      if (response.ok) this.open();
    }

    async removeLine(line) {
      await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 }),
      });
      await this.refresh();
    }
  }

  customElements.define('mm-cart-drawer', MMCartDrawer);

  window.MMCart = {
    add(variantId, quantity) {
      const el = document.querySelector('mm-cart-drawer');
      return el ? el.add(variantId, quantity) : Promise.resolve();
    },
    open() {
      document.querySelector('mm-cart-drawer')?.open();
    },
    close() {
      document.querySelector('mm-cart-drawer')?.close();
    },
    refresh() {
      return document.querySelector('mm-cart-drawer')?.refresh();
    },
  };
})();
